export default __webpack_public_path__ + "static/media/ri_delete-bin-line.ce4e442c.svg";